import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Button, FormControlLabel, Chip, TextField, Radio, RadioGroup, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Icon, BackdropLoader } from '@livable/saas-react-components';
import { BigInfoAlert } from 'src/components/general/BigAlerts';
import useStyles from './styles';
import DOMPurify from 'dompurify';
export const CreateForm = observer(_ref => {
  let handleModalStates = _ref.handleModalStates,
    handleModalClose = _ref.handleModalClose;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  const _useState = useState('email'),
    _useState2 = _slicedToArray(_useState, 2),
    billAccessType = _useState2[0],
    setBillAccessType = _useState2[1];
  // Prototype: this whole component is unreachable today (its call site in modalContent.jsx is
  // commented out), and nothing here is submitted. Wire this to the property utility before
  // exposing it, or the operator picks a frequency that is silently discarded.
  const _useState3 = useState('Monthly'),
    _useState4 = _slicedToArray(_useState3, 2),
    billFrequencyType = _useState4[0],
    setBillFrequencyType = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    credentialWebsite = _useState6[0],
    setCredentialWebsite = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    credentialUsername = _useState8[0],
    setCredentialUsername = _useState8[1];
  const _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    credentialUserPassword = _useState0[0],
    setCredentialUserPassword = _useState0[1];
  const _useState1 = useState([{
      questionName: '',
      answerName: ''
    }]),
    _useState10 = _slicedToArray(_useState1, 2),
    credentialSecurityQuestions = _useState10[0],
    setCredentialSecurityQuestions = _useState10[1];
  const handleQuestionChanges = (index, field, value) => {
    const credentialSecurityQuestionsInt = [...credentialSecurityQuestions];
    credentialSecurityQuestionsInt[index][field] = value;
    setCredentialSecurityQuestions([...credentialSecurityQuestionsInt]);
  };
  const addNewSecurityQuestionSet = () => {
    setCredentialSecurityQuestions([...credentialSecurityQuestions, {
      questionName: '',
      answerName: ''
    }]);
  };
  const removeSecurityQuestionSet = index => {
    credentialSecurityQuestions.splice(index, 1);
    setCredentialSecurityQuestions([...credentialSecurityQuestions]);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BigInfoAlert, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.auto_billing_info_alert_title')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(t('add_new_property_flow.auto_billing_info_alert_content'))
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.createFormContainer
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.createFormHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.auto_billing_access_bills_title')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.auto_billing_access_bills_description'))), /*#__PURE__*/React.createElement(RadioGroup, {
    onChange: e => {
      setBillAccessType(e.target.value);
    },
    value: billAccessType
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.radioItemWrapper
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Radio, null),
    key: 'email',
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.auto_billing_email_option_title')),
    value: 'email'
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.radioItem
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(t('add_new_property_flow.auto_billing_email_option_description'))
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.radioItemWrapper
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Radio, null),
    key: 'credentials',
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.auto_billing_website_option_title')),
    value: 'credentials'
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.radioItem
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('add_new_property_flow.auto_billing_website_option_description')), billAccessType === 'credentials' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    className: "".concat(classes.radioItemGeneralSpacing),
    label: t('add_new_property_flow.auto_billing_management_service_website'),
    variant: "outlined",
    fullWidth: true,
    value: credentialWebsite,
    onChange: e => setCredentialWebsite(e.target.value)
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.radioItemGeneralSpacing)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.auto_billing_credentials')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, t('add_new_property_flow.auto_billing_credentials_description'))), /*#__PURE__*/React.createElement(Chip, {
    className: "".concat(classes.radioItemGeneralSpacing, " ").concat(classes.credentialsInfo),
    label: t('add_new_property_flow.auto_billing_credentials_info_block'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "info"
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.radioItemGeneralSpacing)
  }, /*#__PURE__*/React.createElement(TextField, {
    className: "".concat(classes.credentialsInput),
    label: t('general.username'),
    variant: "outlined",
    value: credentialUsername,
    onChange: e => setCredentialUsername(e.target.value)
  }), /*#__PURE__*/React.createElement(TextField, {
    className: "".concat(classes.credentialsInput),
    label: t('general.password'),
    variant: "outlined",
    value: credentialUserPassword,
    onChange: e => setCredentialUserPassword(e.target.value)
  })), credentialSecurityQuestions.map((i, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.radioItemGeneralSpacing),
      key: index
    }, /*#__PURE__*/React.createElement(TextField, {
      className: "".concat(classes.securityQuestionsInput),
      label: t('general.question') + ' ' + (index + 1),
      variant: "outlined",
      value: i.questionName,
      onChange: e => handleQuestionChanges(index, 'questionName', e.target.value)
    }), /*#__PURE__*/React.createElement(TextField, {
      className: "".concat(classes.securityQuestionsInput, " ").concat((credentialSecurityQuestions === null || credentialSecurityQuestions === void 0 ? void 0 : credentialSecurityQuestions.length) <= 1 ? '' : classes.securityQuestionsInputAnswer),
      label: t('general.answer') + ' ' + (index + 1),
      variant: "outlined",
      value: i.answerName,
      onChange: e => handleQuestionChanges(index, 'answerName', e.target.value)
    }), (credentialSecurityQuestions === null || credentialSecurityQuestions === void 0 ? void 0 : credentialSecurityQuestions.length) > 1 && /*#__PURE__*/React.createElement(Button, {
      className: "".concat(classes.securityQuestionsDeleteBtn),
      variant: "actionIcon",
      size: 'large',
      onClick: () => removeSecurityQuestionSet(index),
      'custom-attribute': '628-new-billing-module'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "trash"
    })));
  }), /*#__PURE__*/React.createElement(Button, {
    className: "".concat(classes.radioItemGeneralSpacing),
    variant: "actionIcon",
    onClick: addNewSecurityQuestionSet,
    'custom-attribute': '629-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.auto_billing_bill_add_security_questions'))))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.mdSection, " ").concat(classes.billFrequencySection)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.bill_frequency')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: 'light',
    className: classes.xssSection
  }, t('add_new_property_flow.auto_billing_bill_frequency_select')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: billFrequencyType,
    exclusive: true,
    onChange: e => {
      setBillFrequencyType(e.target.value);
    }
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "Monthly"
  }, t('general.month')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "BiMonthly"
  }, t('general.bi_monthly')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "Trimonthly"
  }, t('general.quarterly')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "Annually"
  }, t('general.annually')))))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooterAlert
  }, /*#__PURE__*/React.createElement(BigInfoAlert, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.auto_billing_footer_info_alert')))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '630-new-billing-module'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    disabled: false,
    onClick: () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      handleModalStates && handleModalStates('activate');
    },
    'custom-attribute': '631-new-billing-module'
  }, t('add_new_property_flow.save_and_close')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: false
  }));
});